// extracted by mini-css-extract-plugin
export var navigation = "index-module--navigation--whuQS";
export var root = "index-module--root--m0IqK";
export var rootHidden = "index-module--root-hidden--OVWYJ";